import { trim } from 'lodash';
import { expiryRedeemBy } from '@dashboard/components/DiscountsCoupons/couponExpiry';
import request from '@dashboard/services/request';
import { scopeRules } from '@dashboard/components/DiscountsCoupons/couponScope';
import { formatPriceInput } from '@dashboard/services/formatting';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const saveCoupon = (body, sellerId, token) =>
  request(`${apiUrl}/sellers/${sellerId}/coupons`, token, {
    body: JSON.stringify(body),
    method: 'POST',
  });

// The create call refuses a code another live coupon of the seller has, matched exactly as here.
// A failed check lets the merchant carry on; the create call still guards.
export const isCodeTaken = async (code, sellerId, token) => {
  const query = new URLSearchParams({ search: code, limit: '100' });
  try {
    const response = await request(`${apiUrl}/sellers/${sellerId}/coupons?${query}`, token);
    return (response?.data ?? []).some(coupon => coupon.code === code);
  } catch {
    return false;
  }
};

export const buildCouponBody = ({ limitScope, scopePages = [], expires, ...values }) => {
  const body = {
    ...values,
    rules: scopeRules({ limitScope, scopePages }),
    code: trim(values.code),
    amountOff:
      values.discountType === 'amountOff'
        ? formatPriceInput(values.amountOff, values.currency)
        : null,
    percentOff: values.discountType === 'percentOff' ? Number(values.percentOff) : null,
  };

  const redeemBy = expiryRedeemBy({ expires, ...values });
  if (redeemBy) body.redeemBy = redeemBy;

  return body;
};

export const copyText = async text => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
